import React, { PureComponent, Fragment } from 'react';
import { Link } from "react-router-dom";
import {
  Card, CardBody, Row, Col, Nav, NavLink, NavItem, TabContent, TabPane, Container, ButtonToolbar
} from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import buyersListActions from '../../../../redux/actions/buyersListActions';
import { Badge, Table } from 'reactstrap';
import { Tooltip } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Panel from './../../../../shared/components/Panel';
import EmptyBuyersList from '../../../BuyersLists/components/EmptyBuyersList';
import LinearLoading from '../../../../shared/components/LinearLoading';
import BuildingIcons from '../../../../shared/components/BuildingIcons';
import Slider from 'react-slick';
import ArrowRightIcon from 'mdi-react/ArrowRightDropCircleIcon';
import ArrowLeftIcon from 'mdi-react/ArrowLeftDropCircleIcon';
import MainIcon from 'mdi-react/HomeCityOutlineIcon';
import CheckboxMarkedCircleIcon from 'mdi-react/MagnifyIcon';
import moment from "moment";
import { _axiosCall } from '../../../../shared/helpers/apicalls';
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
  isTablet
} from "react-device-detect";
import {
	buildingFL,
	propertyFL,
	_capitalizeText,
	_getBuildingURL,
	_shouldShow,
	_formatNumber,
	_formatPrice,
	UnitCurrentStatus,
	_nameToUrl,
	BuildingPhoto,
	BuildingStageBadge,
	BuildingCurrentStatus,
	_replaceAbbreviations
} from "../../../../shared/helpers/utils";

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const apiURL = process.env.API_ROOT;
const styles = theme => ({
	  root: {
	    display: 'flex',
	    flexDirection: 'column',
	    //marginLeft:"-8px",
	    marginBottom:"15px",
	    alignItems: 'left',
	    '& > *': {
		   
	    },
	  },
	  button:{
		'&.selected' :{
		    background:"#D1D6E0"
	    },
	    fontSize:11,
	    width:90
	  }
	});
const EmptyList = ({title, type}) => {
	return (
		<Card>
		<CardBody style={{padding:15}}>
		<Table responsive className="table-striped trend-buildings">
		  <tbody>
		  <tr>
			  <th colSpan={2}><h5 className="bold-text">{title}</h5></th>
			  
		  </tr>
		  {type === "properties" ?
		  <tr>
			  <td colSpan={2}>
			  <div className="light-text">No unit viewed yet</div>	
			  <br/>			  
				<Link to="/inventory">
								 
					 <div>
						 <span className="link-text">Search Units &raquo;</span>
					 </div>
				 </Link>
			  </td>
			</tr>
			:
			<tr>
			  <td colSpan={2}>
			  <div className="light-text">No building viewed yet</div>	
			  <br/>			  
				<Link to="/building-database/sale/sponsor">
								 
					 <div>
						 <span className="link-text">Search Buildings &raquo;</span>
					 </div>
				 </Link>
			  </td>
			</tr>
		}
		</tbody>
		</Table>
		
		</CardBody>
		</Card>	 
	
	)
}	
const ShowBuildings = ({data, title, color, period, handleBuildingClick}) => {
	
	if(data === false){
		return (
			 <EmptyList title={title} type={"buildings"}/>
		 );
	}
	
	
	return (
		<Card>
		<CardBody style={{padding:15,background:"#FFF"}}>
		 
	    <Table responsive className="table-striped trend-buildings" style={{textAlign:"left"}}>
	      <tbody>
	      <tr>
	      	<th colSpan={2}><h5 className="bold-text" style={{margin:0}}>{title}</h5></th>
	      </tr>
	      {data && Array.isArray(data) && data.map((bldg, i) => {
		      
		        const item = bldg.building ? bldg.building : false;
		        
		        if(!item) return null;
		      	const buildingNameOrAdr = item.name 
			      ? _capitalizeText(item.name)
			      : item.display_full_street_address
			        ? _capitalizeText(item.display_full_street_address)
			        : _capitalizeText(item.full_street_address);
				const adr = item.display_full_street_address ? item.display_full_street_address : item.full_street_address;
				const unitURL = _getBuildingURL(item, 'building_slugs');
		      return (
			 
				      <tr key={i} style={{border:0,cursor:"pointer"}} onClick={(e)=>{handleBuildingClick(e, item)}}>
				      	<td className="photo">
				  			<BuildingPhoto item={item} />
						</td>      				       	
						<td>
								<div>{buildingNameOrAdr}</div>
								<span className="light-text small-text" style={{color:"#858AA1"}}>{item.neighborhood && item.neighborhood[0] ? `${_capitalizeText(item.neighborhood[0])}, ` : ''} {_capitalizeText(item.borough)}
								 {/*_capitalizeText(item.borough)*/}
								 </span>
								<br/> 	
								{/* <span className="light-text small-text" style={{color:"#858AA1"}}>{item.building_status == 'resale' && item.number_of_buildings > 1 && item.tax_assessed_total_units > 1 ?  _formatNumber(item.tax_assessed_total_units) :  _formatNumber(item.total_units)} Total Units</span>*/}
										
							
						</td>  
						{false && !isMobile && 
						<td className="views">						
				  				<span className="light-text small-text"  style={{color:"#858AA1"}}>  {_capitalizeText(moment(bldg.created_timestamp).fromNow())}</span>
						</td>
						}  
			          </tr>
			      
			    )
		      
	      })}
	        
	       
	      </tbody>
	    </Table>
	    
		</CardBody>
		</Card>

    )
}


class RecentHistory extends PureComponent {
	constructor(props) {
	    super(props);
	    this.state = {
	      fetchInProgress: false,
	      recent_buildings: null,
		  trending_buildings: null,
		  sponsor_buildings: null,
		  resale_buildings: null,
	      period: "today",
		  limit : isMobile ? 3 : 5
	    };
	}
	
	componentDidUpdate(prevProps, prevState, snapshot) {
		if(this.state.period !== prevState.period){
			//this._getActivity();
		}
		
	}

	componentDidMount() {
		//this._getActivity();
		
		const sponsorBuildingIds = [
			"b-1-1-wall-st-10005",
			"b-1-305-park-ave-10022",
			"b-1-18-thames-st-10006",
			"b-1-240-south-street-10002",
			"b-4-13102-40th-rd-11354",
			"b-1-41-w-81st-st-10024",
			"b-4-2615-4th-st-11102",
			"b-4-14461-northern-blvd-11354",
			"b-1-141-e-47th-st-10017",
			"b-4-5801-queens-blvd-11377",
			"b-1-720-w-end-ave-10025",
			"b-4-1201-broadway-11106",
			"b-4-13818-northern-blvd-11354",
			"b-4-14449-northern-blvd-11354",
			"b-3-9-dekalb-ave-11201",
			"b-1-556-w-48th-st-10036",
			"b-4-3361-prince-st-11354",
			"b-4-2411-queens-plz-n-11101",
			"b-4-1135-46th-ave-11101",
			"b-4-3041-vernon-blvd-11102",
			"b-3-330-kent-ave-11249",
			"b-1-17-w-86th-st-10024",
			"b-1-25-broad-st-10004",
			"b-4-1442-110th-st-11356",
			"b-3-101-pacific-st-11201",
			"b-1-20-river-ter-10282",
			"b-1-80-claremont-ave-10027",
			"b-4-7829-austin-st-11375",
			"b-3-2282-cropsey-ave-11214",
			"b-4-3-court-sq-11101",
			"b-1-64-11th-ave-10011",
			"b-1-428-e-58th-st-10022",
			"b-4-3712-33rd-st-11101",
			"b-1-250-w-96th-st-10025",
			"b-1-232-e-46th-st-10017",
			"b-3-105-york-st-11201",
			"b-2-1719-lacombe-ave-10473",
			"b-1-315-n-end-ave-10282",
			"b-4-1150-46th-rd-11101",
			"b-4-9725-64th-ave-11374",
			"b-1-609-2nd-ave-10016",
			"b-3-462-kent-ave-11249",
			"b-1-216-w-58th-st-10019",
			"b-1-3-park-row-10038",
			"b-3-323-bergen-st-11217",
			"b-1-68-w-139th-st-10037",
			"b-1-200-e-34th-st-10016",
			"b-3-126-willoughby-st-11201",
			"b-3-180-front-st-11201",
			"b-1-50-w-66th-st-10023"
		];
		
		const resaleBulidingIds = [
			"b-1-432-w-42nd-st-10036",
			"b-1-46-w-54th-st-10019",
			"b-1-50-west-st-10006",
			"b-4-4502-83rd-st-11373",
			"b-1-408-w-52nd-st-10019",
			"b-4-13103-40th-rd-11354",
			"b-4-6405-woodside-ave-11377",
			"b-4-13517-northern-blvd-11354",
			"b-4-7166-parsons-blvd-11365",
			"b-4-3519-leavitt-st-11354",
			"b-4-13202-maple-ave-11355",
			"b-4-3806-union-st-11354",
			"b-3-6-nevins-st-11217",
			"b-4-2117-31st-ave-11106",
			"b-1-545-w-30th-st-10001",
			"b-1-72-vestry-st-10013",
			"b-4-2520-41st-ave-11101",
			"b-4-3400-146th-st-11354",
			"b-4-2515-27th-st-11102",
			"b-1-14-w-40th-st-10018",
			"b-1-19-park-pl-10007",
			"b-1-230-e-20th-st-10003",
			"b-1-399-e-8th-st-10009",
			"b-3-2107-bedford-ave-11226",
			"b-4-8714-51st-ave-11373",
			"b-1-172-madison-ave-10016",
			"b-3-248-webster-ave-11230",
			"b-4-14328-41st-ave-11355",
			"b-1-200-e-95th-st-10128",
			"b-1-27-wooster-st-10013",
			"b-1-68-watts-st-10013",
			"b-3-118-walton-st-11206",
			"b-3-464-wythe-ave-11249",
			"b-3-869-57th-st-11220",
			"b-4-1310-jackson-ave-11101",
			"b-1-301-e-61st-st-10065",
			"b-1-75-e-110th-st-10029",
			"b-4-10103-radcliff-ave-11368",
			"b-4-4138-college-point-blvd-11355",
			"b-1-177-w-137th-st-10030",
			"b-3-1367-59th-st-11219",
			"b-4-3728-97th-st-11368",
			"b-1-180-e-88th-st-10128",
			"b-1-216-central-park-s-10019",
			"b-3-1501-voorhies-ave-11235",
			"b-3-372-avenue-y-11223",
			"b-4-7412-46th-ave-11373",
			"b-1-432-park-ave-10022",
			"b-1-959-1st-ave-10022",
			"b-3-1587-e-19th-st-11230"
		]
		
		let resData = {};
		
		function selectAndCombine(list1, list2, resData) {
			// Shuffle the array and select 5 random items
			function getRandomItems(arr, count) {
				return arr
					.sort(() => Math.random() - 0.5) // Shuffle the array
					.slice(0, count); // Take the first 'count' items
			}
		
			const selectedFromList1 = getRandomItems(list1, 5);
			const selectedFromList2 = getRandomItems(list2, 5);
			
			// Combine both selected arrays
			return {list1: selectedFromList1, list2: selectedFromList2};
		}

		const bldgIDs = selectAndCombine(sponsorBuildingIds, resaleBulidingIds);
		resData = {"sponsor_buildings" : bldgIDs.list1.map(id => {return {building: id}}), "resale_buildings" : bldgIDs.list2.map(id => {return {building: id}})}
		console.log(resData)
		this._getBuildings([...bldgIDs.list1, ...bldgIDs.list2], resData);
		
	  	
	}
	_setBuyersList = (res) => {	  
		 const list = res.docs ? res.docs.map(building => {
			 return Object.assign({}, building, this.props.savedBuildings.filter(item => item.key === building.key)[0]);
		 }) : []
		 this.setState({ 
			buyersList: list,
			incompleteMyBuyersLists: list.filter(item => !item.completed),
			completedMyBuyersLists: list.filter(item => item.completed),		
		});
    }
	_getActivity = async () => {
			
		const { limit } = this.state;
		const { type, user } = this.props;
		
		if (!this.state.fetchInProgress) {
			this.setState(prevState => ({ fetchInProgress: true, }));
		}
		let dateQuery = {
			"$gte": moment().add(-1, 'days').format('YYYY-MM-DD')
		}
		
		const queryData = [
			{
				"$addFields": {
					"formattedDate": {
						"$dateToString": {
							"format": "%Y-%m-%d",
							"date": "$created_timestamp"
						}
					}
				}
			},
			{
				"$match": {
					"$and": [
						
						{
							"event_type": "buildingView"
						}
					]
				}
			},
			{
				"$unwind": {
					"path": "$building"
				}
			},
			{
				"$facet": {
					"trending_buildings": [
						{
							"$match": {
								"$and": [
									{
										"building.borough": {
											"$exists": true
										}
									},
									{
										"formattedDate": dateQuery
									},
									{
										"building.building_status" : { "$in" : ["sponsor", "resale"] }
									},
								]
								
							}
						},
						{
							"$group": {
								"_id": {
									"building": "$building.key"
								},
								"count": {
									"$sum": 1
								}
							}
						},
						{
							"$sort": {
								"count": -1
							}
						},
						{
							"$limit": 5
						}
					],
					"recent_buildings": [
						{
							"$match": {
								"$and": [
									{
										"user_key": { "$in" : [user.id, user.id.toString().toLowerCase()] }
									},
									{
										"event_type": "buildingView"
									}
								]
							}
						},
						{
							"$group": {
								"_id": {
									"building": "$building.key"
								},
								"created_timestamp": {
									"$max": "$created_timestamp"
								},
								"count": {
									"$sum": 1
								}
							}
						},
						{
							"$sort": {
								"created_timestamp": -1
							}
						},
						{
							"$limit": 5
						}
					]
					
				}
			}
		]
		
		
				 
		let axiosData = {
			url: apiURL + "/buyerslist/event/aggregate?cache=60",
			method: "post",
			query: queryData
		};

		let response = await _axiosCall(axiosData)
		.then(res => {
			
			const buildingIDs = [];
			const propertyIDs = [];
			if(res && res[0]){
				
				if(res[0]["trending_buildings"] && res[0]["trending_buildings"].length>0){
					res[0]["trending_buildings"].map(building => {
						 buildingIDs.push(building._id.building);
					})
					
				}else{
					this.setState({ buildings : false, fetchInProgress : false, buildingsFetchInProgress: false });
				}
				if(res[0]["recent_buildings"] && res[0]["recent_buildings"].length>0){
					res[0]["recent_buildings"].map(building => {
					 	buildingIDs.push(building._id.building);
					})
					
				}else{
					this.setState({ buildings : false, fetchInProgress : false, buildingsFetchInProgress: false });
				}
				
				this._getBuildings(buildingIDs, res[0]);
				
				
				
			}
		})
		.catch(error => {
			console.log("error: " + error);
		});
		
		
  };
  
  _getBuildings = async (_buildingIDs, resData) => {
		const signedIn = true; //this.props.reduxState && this.props.reduxState.user.authenticated;
		const { limit } = this.state;
			
		if (!this.state.buildingsFetchInProgress) {
			this.setState(prevState => ({ buildingsFetchInProgress: true, }));
		}
		var q = "key:("+_buildingIDs.join(" ")+")";
		
		var fq = [
			"deleted:false"			
		];


		let axiosData = {
			url: apiURL + "/query/we3-buildings?cache=60",
			method: "post",
			query: {
				q: q,
				fq: fq,
				fl: buildingFL,
				wt: "json",
				rows: 50
			}
		};
		

		let formattedData = await _axiosCall(axiosData)
			.then(res => {
				//this._setBuyersList(res);
				if(res && res.docs){
					res.docs.map(bldg => {
					
						
						// if(resData['recent_buildings'].filter(b => b._id.building == bldg.key).length>0){
						// 	resData['recent_buildings'].filter(b => b._id.building == bldg.key)[0]['building'] = bldg;
						// }
						// 
						// if(resData['trending_buildings'].filter(b => b._id.building == bldg.key).length>0){
						// 	resData['trending_buildings'].filter(b => b._id.building == bldg.key)[0]['building'] = bldg;
						// }
						if(resData['sponsor_buildings'].filter(b => b.building == bldg.key).length>0){
							resData['sponsor_buildings'].filter(b => b.building == bldg.key)[0]['building'] = bldg;
						}
						if(resData['resale_buildings'].filter(b => b.building == bldg.key).length>0){
							resData['resale_buildings'].filter(b => b.building == bldg.key)[0]['building'] = bldg;
						}
						
					});
					
					console.log(resData)
					this.setState({ sponsor_buildings : resData['sponsor_buildings'].filter(b => b.building).slice(0, limit), resale_buildings: resData['resale_buildings'].filter(b => b.building).slice(0, limit), fetchInProgress : false, buildingsFetchInProgress: false });
				}else{
					this.setState({ recent_buildings : resData['recent_buildings'].slice(0, limit), trending_buildings:resData['trending_buildings'].slice(0, limit), fetchInProgress : false, buildingsFetchInProgress: false });
				}
				
			})
			.catch(error => {
				console.log("error: " + error);
			});
			

		// console.log(formattedData)
		return formattedData;
  };
  
  
  handleBuildingClick = (event, building) => {
	  const { addTag, handleSearch  } = this.props;
	 event.stopPropagation();
	 addTag({type:'building', data: building, id: building.key, name: building.name ?_capitalizeText(building.name) : _capitalizeText(building.display_full_street_address) });	
	 handleSearch();
	 
  };
  
  setPeriod = (period) => {
	  this.setState({period:period})
  }
  
  render(){
	const { savedUnits, totalCount, period, recent_buildings, trending_buildings, sponsor_buildings, resale_buildings, fetchInProgress, buildingsFetchInProgress } = this.state;
	const { classes, type,  } = this.props;
	//if(!data) return null;
	
	if(sponsor_buildings === false && resale_buildings === false) return null;
	return (
	<div>
			  
			   
			   {(fetchInProgress || buildingsFetchInProgress) ?
				   <div>
				   <h5
					style={{
					  fontWeight:800,
					  textAlign:"center",
					  textTransform:"uppercase"
					}}
					>Loading Popular Buildings</h5>
				   <LinearLoading />
				   <div style={{height:357}}>
				   	
				   </div>
				   </div>
				   
				   :
				   <div>
				   <h5
					 style={{
					   fontWeight:800,
					   textAlign:"center",
					   textTransform:"uppercase"
					 }}
					 >Or choose a popular building</h5>
				   <Row>
					  <Col md={6} className={"mb-2"}>
						  <ShowBuildings data={sponsor_buildings} title={"New Development"} color={"#4ce1b6"} period={period} handleBuildingClick={this.handleBuildingClick} />
					  </Col>
					  <Col md={6} className={"mb-2"}>
						  <ShowBuildings data={resale_buildings} title={"Resale"} color={"#4ce1b6"} period={period}  handleBuildingClick={this.handleBuildingClick}/>
					  </Col>
					 					   	  
					   
				  </Row>
				   </div>
				
			   }
			   
			      
	</div>
	
	)
	
   }
};

RecentHistory.propTypes = {
  t: PropTypes.func.isRequired,
};


export default withStyles(styles,  { withTheme: true })(RecentHistory);
